import React, {useCallback} from 'react';
import OtpAuthScreen from '../../../components/common/OtpAuthScreen';
import {useRenewalClick} from '../context/RenewalClickContext';
import {sendRenewalCode, verifyRenewalCode, fetchRenewalPageModel} from '../api/renewalClickApi';

const AuthScreen = () => {
  const {shortLinkKey, authMethods, maskedPhone, customerName, setPageData} = useRenewalClick();

  const handleSendCode = useCallback((method) => sendRenewalCode(shortLinkKey, method), [shortLinkKey]);

  const handleVerifyCode = useCallback((code) => verifyRenewalCode(shortLinkKey, code), [shortLinkKey]);

  const handleAuthenticated = useCallback(async () => {
    const pageData = await fetchRenewalPageModel(shortLinkKey);
    setPageData(shortLinkKey, pageData);
  }, [shortLinkKey, setPageData]);

  return (
    <OtpAuthScreen
      authMethods={authMethods}
      maskedPhone={maskedPhone}
      titleId='renewalClick.auth.title'
      titleValues={{name: customerName}}
      descriptionId='renewalClick.auth.description'
      descriptionMaxWidth={340}
      onSendCode={handleSendCode}
      onVerifyCode={handleVerifyCode}
      onAuthenticated={handleAuthenticated}
    />
  );
};

export default AuthScreen;
